import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToWords } from 'to-words';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { from } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { concatMap, finalize } from 'rxjs/operators';

@Component({
  selector: 'app-receiptpackagebook',
  templateUrl: './receiptpackagebook.component.html',
  styleUrls: ['./receiptpackagebook.component.scss']
})
export class ReceiptpackagebookComponent implements OnInit {

  // -------------------------
  // VARIABLES
  // -------------------------
  sellerData: any;
  book_data: any[] = [];
  inputValues: any[] = [];

  totalAmount = 0;
  totalInWords = '';
  receiptNo: any;
  today = new Date();
  seamt: any;
  receivedamt = 0;
  orderno: any;

  // Guard flag to prevent double-save on double-click / double-bind
  isSaving = false;

  // -------------------------
  // CONSTRUCTOR
  // -------------------------
  constructor(
    private dialogRef: MatDialogRef<ReceiptpackagebookComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private toastr: ToastrService
  ) {}

  // -------------------------
  // INIT
  // -------------------------
  ngOnInit(): void {

    console.log('Dialog Data:', this.data);

    // Data from parent
    this.sellerData   = this.data.formData;
    this.book_data    = this.data.bookData    || [];
    this.inputValues  = this.data.inputValues || [];

    this.totalAmount  = this.data.total_amt || 0;
    this.receiptNo    = this.data.formData?.recptno;
    this.seamt        = this.data.formData?.seamt;
    this.orderno      = this.data.formData?.orderno;
    this.receivedamt  = Number(this.data.formData?.receivedamt) || 0;

    // Convert amount to words
    const toWords = new ToWords();
    this.totalInWords = toWords.convert(this.receivedamt, { currency: true });
  }

  // -------------------------
  // PRINT
  // -------------------------
  print(): void {
    window.print();
  }

  // -------------------------
  // FINAL SAVE METHOD
  // -------------------------
  addBookSellerEntryPackage(): void {

    // Guard: ignore re-entrant calls while a save is already in flight
    if (this.isSaving) {
      return;
    }
    this.isSaving = true;

    const form = this.data.formData;

    // ── EXACT structure matching your Postman JSON ──
    const booksellerbookingdetails: any = {

      bse_id:           this.data.booksellerid || null,

      // Order / Booking
      orderno:          form.orderno          || null,
      bookdate:         form.bookdate         || null,
      recptno:          form.recptno          || null,
      crdtvno:          form.crdtvno          || null,
      seamt:            form.seamt            || null,
      receivedamt:      form.receivedamt      || 0,
      newordeleted:     form.newordeleted     || 'new',

      // Subscriber
      subscribersName:  form.subscribersName  || null,
      subscribersNo:    form.subscribersNo    || null,
      mobileNumber:     form.mobileNumber     || '0',

      // Personal
      title:            form.title            || null,
      titleEnglish:     form.titleEnglish     || '',
      nameRequired:     form.nameRequired     || null,
      nameEnglish:      form.nameEnglish      || '',
      address:          form.address          || null,

      e_address:        form.e_address        || '',
      e_address1:       form.e_address1       || '',
      e_address2:       form.e_address2       || '',

      pincode:          form.pincode          || null,
      pincodeEnglish:   form.pincodeEnglish   || '',

      country:          form.country          || null,
      countryEnglish:   form.countryEnglish   || '',

      state:            form.state            || null,
      stateEnglish:     form.stateEnglish     || '',

      district:         form.district         || null,
      districtEnglish:  form.districtEnglish  || '',

      taluka:           form.taluka           || null,
      talukaEnglish:    form.talukaEnglish    || '',

      mobileNumberField: form.mobileNumberField || '0',
      telephone:        form.telephone        || '',

      email:            form.email            || '',

      dob:              form.dob              || null,
      doa:              form.doa              || null,
      representativeName:   form.representativeName   || '',
      representativeMobile: form.representativeMobile || '',

      gstNumber:        form.gstNumber        || '',
      remark:           form.remark           || '',
      sellertype:       form.sellertype       || null,

      bookname:         form.bookname         || '',
      availablestock:   form.availablestock   || 0,
      authorname:       form.authorname       || '',

      crepname:         form.crepname         || '',
      repmobno1:        form.repmobno1        || '',
      officerepname:    form.officerep        || '',

      DeliveryMode:     form.DeliveryMode     || '',
      DistributiveRep:  form.DistributiveRep  || '',
      DistributionMode: form.DistributionMode || '',
      SubDistMode:      form.SubDistMode      || '',

      iscomplimentary:  this.data.iscomplementary ? 'Y' : 'N',
      isSponsor:        this.data.isSponsor        ? 'Y' : 'N',

      complimentaryOption: form.complimentaryOption || '',

      bookSellerGstType: form.bookSellerGstType || 'NO_GST',
      gstPercentage:     form.gstPercentage     || 0,
      gstAmount:         form.gstAmount         || 0,
      sgstAmount:        form.sgstAmount        || 0,
      cgstAmount:        form.cgstAmount        || 0,
      igstAmount:        form.igstAmount        || 0,
      totalAmount:       form.totalAmount       || 0,

      invoice_generated: 'N'
    };

    console.log('Booking Payload:', booksellerbookingdetails);

    // ── Save booking ──
    this.service.addBookSellerEntryBookingDetailsPackage(booksellerbookingdetails)
      .subscribe({
        next: (res: any) => {
          console.log('Booking Saved, ID:', res.id);

          // ── Save each book one by one ──
          from(this.book_data).pipe(
            concatMap((book: any, i: number) => {

              const bookdata: any = {
                bse_id:         res.id,
                book_name:      book.bookname,
                author_name:    book.author,
                yearwisebook:   book.yearwisebook   || null,
                agentprice:     book.agentprice      || 0,

                total_amt:      (this.data.total_amt || 0) + (this.data.shipping_total || 0),
                totalcopies:    book.bookcopies      || 0,

                iscomplementary: booksellerbookingdetails.iscomplimentary,
                isSponsor:       booksellerbookingdetails.isSponsor,

                book_price:      book.price          || 0,
                book_sale_price: book.saleprice       || 0,
                discount:        book.discount        || 0,
                discountamt:     book.discountamt     || this.inputValues[i]?.totalad  || 0,
                totalad:         book.totalad         || this.inputValues[i]?.totalad  || 0,
                book_copies:     book.bookcopies      || this.inputValues[i]?.bookcopies || 0,
                total:           book.total           || this.inputValues[i]?.total    || 0,
                shippingcharge:  book.shippingcharging || 0,
                repcomprecent:   book.repcompercent   || 0,
                commissionamt:   book.commissionamt   || 0,

                sponsor_price:   this.inputValues[i]?.price      || 0,
                sponsor_totalad: this.inputValues[i]?.totalad    || 0,
                sponsor_copies:  this.inputValues[i]?.bookcopies || 0,
                sponsor_total:   this.inputValues[i]?.total      || 0,

                complementary_copies: book.complementarycopies
                                      || this.inputValues[i]?.bookcopies
                                      || 0,
              };

              console.log('Book Payload:', bookdata);
              return this.service.addBookDataPackage(bookdata);
            }),

            finalize(() => {
              this.isSaving = false;
              this.toastr.success('Package Saved Successfully!');
              this.dialogRef.close('confirm'); // ✅ closes dialog and triggers parent reset

              // 🔄 Refresh the page after a short delay so the toast is visible
              setTimeout(() => {
                window.location.reload();
              }, 800);
            })
          ).subscribe({
            error: (err) => {
              console.error('Book save error:', err);
              this.toastr.error('Error saving book data. Check console.');
              this.isSaving = false;
            }
          });
        },
        error: (err) => {
          console.error('Booking save error:', err);
          this.toastr.error('Error saving booking. Check console.');
          this.isSaving = false;
        }
      });

  }
}